(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5588],{

/***/ 42692:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/deal/[id]",
      function () {
        return __webpack_require__(43649);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 34906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


var DealPageCol = function(param) {
    var title = param.title, subTitle = param.subTitle, children = param.children, _fullWidth = param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "flex h-full w-full ".concat(fullWidth ? "" : "rounded-2xl", " bg-white"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "flex w-full flex-col",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "w-full pt-6",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "px-6 font-gt-haptik text-heading-5-mobile font-bold text-black md:text-heading-5",
                        children: title
                    }),
                    subTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "px-6 text-sm text-neutral-50",
                        children: subTitle
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: children
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DealPageCol);


/***/ }),

/***/ 49842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _components_Table_DealPageCol__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34906);
/* harmony import */ var _components_cards_EmptyBidCard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49141);
/* harmony import */ var _components_cards_LicensedNft__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17431);





var LiscensedAssetsTable = function(param) {
    var executed_bids = param.executed_bids;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "col-span-2 flex flex-col-reverse gap-8 md:flex-row",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "w-full",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Table_DealPageCol__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                title: "Licensed Assets",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "mx-4 w-full justify-self-center pb-6 pt-8 md:mx-6",
                    children: (executed_bids === null || executed_bids === void 0 ? void 0 : executed_bids.length) > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "hidden-scroll flex snap-x snap-mandatory space-x-4 overflow-scroll ",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "hidden-scroll flex w-full snap-x snap-mandatory gap-2 md:grid md:grid-cols-3 md:gap-4 md:overflow-scroll",
                            children: executed_bids.map(function(data) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-span-1 snap-start",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_cards_LicensedNft__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                        tokenId: data.token_id,
                                        collectionAddress: data.nft_contract_address,
                                        tokenName: String(data.Collection.name),
                                        brand: data.Deal.Brand,
                                        dealName: data.Deal.title,
                                        dealId: data.Deal.id
                                    })
                                }, "".concat(data.token_id).concat(data.Deal.id));
                            })
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex w-full items-center justify-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_cards_EmptyBidCard__WEBPACK_IMPORTED_MODULE_3__/* .EmptyBidCard */ .P, {
                            hasButton: false,
                            title: "No Licensed Assets"
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LiscensedAssetsTable);


/***/ }),

/***/ 49141:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ EmptyBidCard; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var react_icons_tb___WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58920);
/* harmony import */ var _components_UI_buttons_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21489);





var EmptyBidCard = function(param) {
    var title = param.title, _hasButton = param.hasButton, hasButton = _hasButton === void 0 ? false : _hasButton, _buttonPath = param.buttonPath, buttonPath = _buttonPath === void 0 ? "/deals" : _buttonPath, _buttonText = param.buttonText, buttonText = _buttonText === void 0 ? "View Opportunities" : _buttonText;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex w-full flex-col place-content-center place-items-center py-8 text-black",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_tb___WEBPACK_IMPORTED_MODULE_4__/* .TbIdOff */ .T_6, {
                className: "text-heading-3"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-1/2 justify-center p-4 text-center font-gt-haptik text-heading-6-mobile md:text-heading-6",
                children: title
            }),
            hasButton ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                className: "flex items-center py-2",
                href: buttonPath,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UI_buttons_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                    size: _components_UI_buttons_Button__WEBPACK_IMPORTED_MODULE_3__/* .ButtonSize.primary */ .qE.primary,
                    type: _components_UI_buttons_Button__WEBPACK_IMPORTED_MODULE_3__/* .ButtonType.primary */ .L$.primary,
                    children: buttonText
                })
            }) : null
        ]
    });
};


/***/ }),

/***/ 17431:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96577);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _components_navigation_ArrowButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56245);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36630);
/* harmony import */ var _hooks_useNftMeta__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77253);
/* harmony import */ var _utilities_createBucketUrl__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37785);
/* harmony import */ var _utilities_functions__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12477);
/* harmony import */ var _Avatar__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(89646);
/* harmony import */ var _AvatarInfo__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(10934);
/* harmony import */ var _TitleVerified__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41571);











var LicensedNft = function(param) {
    var collectionAddress = param.collectionAddress, tokenId = param.tokenId, tokenName = param.tokenName, brand = param.brand, dealName = param.dealName, dealId = param.dealId;
    var network = (0,_utilities_functions__WEBPACK_IMPORTED_MODULE_7__/* .getAlchemyNetwork */ .Op)(_constants_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHAIN_ID */ .Kj);
    var networkName = (0,_utilities_functions__WEBPACK_IMPORTED_MODULE_7__/* .getOpenseaNetworkName */ .Jj)(_constants_constants__WEBPACK_IMPORTED_MODULE_4__/* .CHAIN_ID */ .Kj);
    var nftThumbnail = (0,_hooks_useNftMeta__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        collectionAddress: collectionAddress,
        tokenId: tokenId,
        network: network
    }).nftThumbnail;
    var _company_name;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: nftThumbnail ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: "https://opensea.io/assets/".concat(networkName, "/").concat(collectionAddress, "/").concat(tokenId),
            rel: "noreferrer",
            target: "_blank",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative h-[411px] w-[301px] overflow-hidden rounded-2xl hover:cursor-pointer md:w-full lg:h-[423px]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute inset-0",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                            unoptimized: true,
                            src: nftThumbnail !== null && nftThumbnail !== void 0 ? nftThumbnail : "",
                            alt: "".concat(tokenName, " #").concat(tokenId),
                            layout: "fill",
                            objectFit: "cover",
                            className: "rounded-lg"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute inset-0 w-full max-w-[347px] rounded-lg bg-gradient-to-t from-primary-main"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "absolute bottom-0 flex w-full items-center justify-between p-6",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "h-full w-full pr-3",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AvatarInfo__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                    contentClasses: "text-white font-regular text-sm",
                                    theme: _TitleVerified__WEBPACK_IMPORTED_MODULE_10__/* .TitleVerifiedTheme.white */ .q.white,
                                    size: _Avatar__WEBPACK_IMPORTED_MODULE_8__/* .AvatarSize.sm */ .DZ.sm,
                                    title: dealName,
                                    primaryInfo: (_company_name = brand.company_name) !== null && _company_name !== void 0 ? _company_name : "",
                                    secondaryInfo: "#".concat(tokenId),
                                    verified: false,
                                    image: (0,_utilities_createBucketUrl__WEBPACK_IMPORTED_MODULE_6__/* .createBucketURL */ .C)(_utilities_createBucketUrl__WEBPACK_IMPORTED_MODULE_6__/* .BucketType.Brand */ .a.Brand, brand.username, brand.updated_at),
                                    textLink: "/deal/".concat(dealId)
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_navigation_ArrowButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                direction: _components_navigation_ArrowButton__WEBPACK_IMPORTED_MODULE_3__/* .ArrowDirection.right */ .n4.right,
                                classes: "text-primary-main"
                            })
                        ]
                    })
                ]
            })
        }) : null
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LicensedNft);


/***/ }),

/***/ 637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);



var SeoHead = function(param) {
    var title = param.title, description = param.description, imageURI = param.imageURI, pagePath = param.pagePath, twitterTitle = param.twitterTitle, twitterDescription = param.twitterDescription;
    var defaultDescription = description !== null && description !== void 0 ? description : "Most people don’t have the resources, time, or connections to truly use their web3 IP. Our goal at OverpassIP is to provide holders with easily accessible opportunities to leverage their NFTs IP. With OverpassIP, the web3 user will seamlessly connect with the Web2 brand. Join us in revolutionizing IP functionality for years to come.";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "shortcut icon",
                type: "image/svg+xml",
                href: "/overpass.svg"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                href: "/favicon.ico"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: defaultDescription
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: imageURI ? imageURI : "/img/OverPassCover.png"
            }, "ogimage"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }, "ogtitle"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: defaultDescription
            }, "ogdesc"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: pagePath !== null && pagePath !== void 0 ? pagePath : "/"
            }, "ogurl"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: "@OverpassIP"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:creator",
                content: "@OverpassIP"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: twitterTitle ? twitterTitle : title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: twitterDescription ? twitterDescription : defaultDescription
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: imageURI ? imageURI : "/img/OverPassCover.png"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SeoHead);


/***/ }),

/***/ 43649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var moment_timezone_custom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33353);
/* harmony import */ var moment_timezone_custom__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment_timezone_custom__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2784);
/* harmony import */ var _components_Table_LiscensedAssetsTable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49842);
/* harmony import */ var _components_common_ErrorComponent__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69397);
/* harmony import */ var _components_head_SeoHead__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(637);
/* harmony import */ var _components_head_seoDescriptionDeal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(84502);
/* harmony import */ var _components_layout_LoadingView__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5431);
/* harmony import */ var _components_layout_PageContainer__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(37742);
/* harmony import */ var _components_sections_DealComponent__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(72235);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(36630);
/* harmony import */ var _hooks_usePageEntrance__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(7414);
/* harmony import */ var _utilities_generated_graphql__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(30207);
















var DealDetail = function(param) {
    var deal = param.deal, ogImage = param.ogImage, pagePath = param.pagePath;
    var ref;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var requestedNumberOfNfts = deal === null || deal === void 0 ? void 0 : deal.CollectionDeals.reduce(function(acc, param) {
        var count = param.count;
        return acc + count;
    }, 0);
    var numberOfCollections = deal === null || deal === void 0 ? void 0 : deal.CollectionDeals.length;
    if (router.isFallback) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_layout_LoadingView__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {});
    }
    if (!deal) {
        // TODO: figure out why this isn't rerouting but fixing old message
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_ErrorComponent__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            description: "Oops! The page you are looking for seems to be missing or may have been moved. We apologize for the inconvenience.",
            title: "Oops!",
            type: "404",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                className: "max-w-sm text-center text-primary-main",
                children: [
                    "If you believe you should have access or need any assistance, please reach out to our team on Twitter at",
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        className: "text-white",
                        href: "https://twitter.com/OverpassIP",
                        target: "_blank",
                        rel: "noreferrer",
                        children: "@OverpassIP."
                    })
                ]
            })
        });
    }
    var getDate = function(date) {
        // create a new moment object from the UTC string
        var dateMoment = moment_timezone_custom__WEBPACK_IMPORTED_MODULE_1___default().utc(date);
        // convert the UTC moment object to the user's local time zone
        var localMoment = dateMoment.tz(moment_timezone_custom__WEBPACK_IMPORTED_MODULE_1___default().tz.guess());
        // format the local moment object as a string in the desired format
        return localMoment.format(_constants_constants__WEBPACK_IMPORTED_MODULE_11__/* .DATE_FORMATS.MMMDYhm */ .lv.MMMDYhm);
    };
    var proposal_expiration = getDate(deal === null || deal === void 0 ? void 0 : deal.bidding_expiration);
    var license_expiration = getDate(deal === null || deal === void 0 ? void 0 : deal.license_expiration);
    var newDeal = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, deal), {
        bidding_expiration: proposal_expiration,
        license_expiration: license_expiration
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0,_hooks_usePageEntrance__WEBPACK_IMPORTED_MODULE_12__/* .usePageEntrance */ .s)();
    var ref1, _name, _payment_currency;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_layout_PageContainer__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        classes: "space-y-4",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "rounded-2xl bg-white px-4 py-6 md:px-14 md:py-16",
            children: [
                (deal === null || deal === void 0 ? void 0 : deal.CollectionDeals.length) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_head_SeoHead__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    imageURI: ogImage,
                    pagePath: pagePath,
                    title: "OverpassIP | Opportunity Review - ".concat(deal === null || deal === void 0 ? void 0 : deal.Brand.company_name, " ").concat(deal === null || deal === void 0 ? void 0 : deal.title),
                    description: (0,_components_head_seoDescriptionDeal__WEBPACK_IMPORTED_MODULE_7__/* .seoDescriptionDeal */ .l)({
                        companyName: (ref1 = deal === null || deal === void 0 ? void 0 : (ref = deal.Brand) === null || ref === void 0 ? void 0 : ref.company_name) !== null && ref1 !== void 0 ? ref1 : "",
                        collectionName: (_name = deal === null || deal === void 0 ? void 0 : deal.CollectionDeals[0].Collection.name) !== null && _name !== void 0 ? _name : "",
                        currency: (_payment_currency = deal.payment_currency) !== null && _payment_currency !== void 0 ? _payment_currency : _utilities_generated_graphql__WEBPACK_IMPORTED_MODULE_13__/* .PaymentCurrency_Enum.Usdc */ .CI.Usdc,
                        minBudget: deal.min_budget,
                        maxBudget: deal.max_budget,
                        royaltyPercentage: deal.royalty_percentage,
                        requestedNumberOfNfts: requestedNumberOfNfts,
                        numberOfCollections: numberOfCollections
                    })
                }) : null,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_sections_DealComponent__WEBPACK_IMPORTED_MODULE_10__/* .DealComponent */ .E, {
                    deal: deal ? newDeal : deal,
                    requestedNumberOfNfts: requestedNumberOfNfts
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Table_LiscensedAssetsTable__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    executed_bids: deal === null || deal === void 0 ? void 0 : deal.executed_bids
                })
            ]
        })
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (DealDetail);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [246,947,3661,5984,8461,5816,7633,6570,6601,9774,2888,179], function() { return __webpack_exec__(42692); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);